import * as XLSX from "xlsx";

import { Button, Input, Loader } from "@mantine/core";
import {
  IconArrowLeft,
  IconLayoutGridFilled,
  IconMail,
  IconSearch,
} from "@tabler/icons-react";
import { Modal, Table, Upload, notification } from "antd";
import { useEffect, useState } from "react";

import { orpcClient } from "@/lib/orpc-client";
import { partitionBatch } from "@/lib/orpc-batch";
import { steelAssemblyBatchCreateInput } from "@/schemas/steelAssembly";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AddDesignBOM() {
  const { t } = useTranslation();
  const [fileUpload, setFileUpload] = useState([]);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false); // <-- loading state
  const [api, contextHolder] = notification.useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const { id } = useParams();
  const navigate = useNavigate();

  const handlePageChange = (page: number, size?: number) => {
    setCurrentPage(page);
    if (size && size !== pageSize) {
      setPageSize(size);
    }
  };

  // Reset pagination when new file is uploaded
  useEffect(() => {
    setCurrentPage(1);
  }, [fileUpload]);

  const rowSelection = {
    fixed: "left" as const,
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows,
      );
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const handleChangePayableDetail = (documentId, value, type) => {
    setFileUpload((prev) => {
      const updatedList = prev.map((payable) => {
        if (payable.documentId === documentId || payable?.key === documentId) {
          return {
            ...payable,
            [type]: value,
          };
        }
        return payable;
      });

      return updatedList;
    });
  };

  const handleChangeFile = (info, setFileUpload) => {
    const file = info.file.originFileObj;
    if (!file) return;

    const isExcel =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel";

    if (isExcel) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        const formattedData = processFileData(jsonData);
        setFileUpload(formattedData);
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const processFileData = (jsonData) => {
    const filteredData = [];
    for (let i = 0; i < jsonData.length; i++) {
      const item = jsonData[i];
      const part = String(Object.values(item)[0]).trim();
      if (part === "SteelAssembly") {
        filteredData.push({
          ...item,
          nextRowEmpty2:
            i + 1 < jsonData.length ? jsonData[i + 1].__EMPTY_2 || "" : "",
        });
      }
    }

    return filteredData.map((item, index) => ({
      key: index,
      name: item?.新建工程 || "",
      b: item?.__EMPTY || "",
      c: item?.__EMPTY_1 || "",
      d: item?.__EMPTY_2 || "",
      e: item?.__EMPTY_3 || "",
      f: item?.__EMPTY_4 || "",
      g: item?.__EMPTY_5 || "",
      h: item?.__EMPTY_6 || "",
      i: item?.__EMPTY_7 || "",
      j: item?.__EMPTY_8 || "",
      k: item?.__EMPTY_9 || "",
      l: item?.__EMPTY_10 || "",
      m: item?.__EMPTY_11 || "",
      n: item?.__EMPTY_12 || "",
      o: item?.nextRowEmpty2 || "",
    }));
  };

  const columns = [
    // {
    //   title: '構件ID',
    //   dataIndex: 'name',

    //   render: (text, i) => {
    //     return (
    //       <Input
    //         placeholder="Input component"
    //         //leftSection={<IconMail size={16} />}
    //         value={i?.name}
    //         onChange={(e) =>
    //           handleChangePayableDetail(i?.documentId || i?.key, e.target.value, 'name')
    //         }
    //       />
    //     );
    //   },
    // },
    {
      title: "構件ID",
      dataIndex: "b",
      fixed: "left" as const,

      render: (text, i) => {
        console.log("text", text);
        console.log("i", i);
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "name",
              )
            }
          />
        );
      },
    },
    {
      title: "構件編號",
      dataIndex: "c",

      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "c",
              )
            }
          />
        );
      },
    },
    {
      title: "安裝位置",
      dataIndex: "d",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "d",
              )
            }
          />
        );
      },
    },
    {
      title: "安裝高程",
      dataIndex: "e",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "e",
              )
            }
          />
        );
      },
    },
    {
      title: "區別",
      dataIndex: "f",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "f",
              )
            }
          />
        );
      },
    },
    {
      title: "拆運號碼",
      dataIndex: "g",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "g",
              )
            }
          />
        );
      },
    },
    {
      title: "拆運說明",
      dataIndex: "h",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "h",
              )
            }
          />
        );
      },
    },
    {
      title: "圖面名稱",
      dataIndex: "i",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "i",
              )
            }
          />
        );
      },
    },
    {
      title: "總寬度",
      dataIndex: "j",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "j",
              )
            }
          />
        );
      },
    },
    {
      title: "總高度",
      dataIndex: "k",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "k",
              )
            }
          />
        );
      },
    },
    {
      title: "總長度",
      dataIndex: "l",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "l",
              )
            }
          />
        );
      },
    },
    {
      title: "總重量",
      dataIndex: "m",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "m",
              )
            }
          />
        );
      },
    },
    {
      title: "總面積",
      dataIndex: "n",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "n",
              )
            }
          />
        );
      },
    },
    {
      title: "斷面規格",
      dataIndex: "o",
      render: (text, i) => {
        return (
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "o",
              )
            }
          />
        );
      },
    },
    {
      title: "",
      fixed: "right",
      render: ({ key }) => {
        return (
          <>
            <div>
              <Button
                variant="filled"
                color="gray"
                style={{ margin: "0.3rem" }}
                radius="md"
                // onClick={async () => {
                //   let result = await apiUserDeleteAccountsPayable({
                //     id: displayAccountPayable[key - 1]?.documentId,
                //   });
                //   fetchPayableData();
                // }}
              >
                編輯
              </Button>
            </div>
          </>
        );
      },
    },
  ];

  const handleUploadExcel = async (data: any[]) => {
    setIsUploading(true);

    try {
      const toStr = (v: unknown) =>
        v === undefined || v === null || v === "" ? "" : String(v);

      const toNum = (v: unknown) => {
        if (v === undefined || v === null || v === "") return null;
        const n = typeof v === "number" ? v : parseFloat(String(v));
        return Number.isFinite(n) ? n : null;
      };

      const items = data.map((element) => ({
        buildingId: id!,
        steelAssemblyId: toStr(element?.b),
        steelAssemblyCode: toStr(element?.c),
        installationLocation: toStr(element?.d),
        installationElevation: toNum(element?.e),
        distinction: toStr(element?.f),
        transportNumber: toStr(element?.g),
        transportDescription: toStr(element?.h),
        drawingName: toStr(element?.i),
        totalWidth: toNum(element?.j),
        totalHeight: toNum(element?.k),
        totalLength: toNum(element?.l),
        totalWeight: toNum(element?.m),
        totalArea: toNum(element?.n),
        metricSizeMark: toStr(element?.o),
      }));

      const parsed = steelAssemblyBatchCreateInput.safeParse({ items });
      if (!parsed.success) {
        setIsUploading(false);
        const firstIssue = parsed.error.issues[0];
        const path = firstIssue?.path.join(".") ?? "";
        api.error({
          message: `通知`,
          description: (
            <div>
              {t("designBOM.validationError")}
              {path ? `：${path}` : ""}
              {firstIssue?.message ? `（${firstIssue.message}）` : ""}
            </div>
          ),
          placement: "topLeft",
          duration: 0,
        });
        return;
      }

      const results = await orpcClient.steelAssembly.create(parsed.data.items);
      const { data: created, errors } = partitionBatch(results);

      setIsUploading(false);

      if (errors.length > 0) {
        api.error({
          message: `通知`,
          description: (
            <div>
              {`${created.length}/${results.length} 筆匯入成功，${errors.length} 筆失敗：${errors
                .slice(0, 3)
                .join("；")}`}
            </div>
          ),
          placement: "topLeft",
          duration: 0,
        });
        return;
      }

      api.success({
        message: `通知`,
        description: (
          <div>
            {t("designBOM.uploadSuccess", { count: created.length })}
          </div>
        ),
        placement: "topLeft",
        duration: 3,
      });
      navigate(`/hrMainPage/designBOM/${id}`);
    } catch (e) {
      setIsUploading(false);
      console.error("Upload error:", e);
      api.error({
        message: `通知`,
        description: (
          <div>
            {(e as any)?.message ||
              t("designBOM.uploadError")}
          </div>
        ),
        placement: "topLeft",
        duration: 0,
      });
    }
  };

  useEffect(() => {
    setIsUploadModalOpen(true);
  }, []);

  return (
    <div className="px-8 m-8">
      {contextHolder}
      {isUploading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader size="xl" color="blue" />
        </div>
      )}
      <div
        className="flex items-center justify-between px-4"
        style={{ backgroundColor: "#ECECEC", marginBottom: "1rem" }}
      >
        <div className="flex justify-start">
          <Button
            variant="filled"
            color="red"
            onClick={() => setFileUpload([])}
          >
            刪除Excel
          </Button>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            color="gray"
            leftSection={<IconArrowLeft size={16} />}
            onClick={() => navigate(`/hrMainPage/designBOM/${id}`)}
          >
            返回設計BOM
          </Button>
          <Button variant="default" onClick={() => setIsUploadModalOpen(true)}>
            匯入構件
          </Button>
          <Button
            variant="default"
            onClick={() => handleUploadExcel(fileUpload)}
          >
            儲存Excel
          </Button>
        </div>
      </div>

      <Modal
        title="匯入Excel檔案"
        open={isUploadModalOpen}
        onCancel={() => setIsUploadModalOpen(false)}
        footer={null}
        width={600}
      >
        <div className="flex flex-col items-center justify-center p-8">
          <Upload
            name="avatar"
            showUploadList={false}
            onChange={(info) => handleChangeFile(info, setFileUpload)}
            accept=".xlsx,.xls"
          >
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-blue-500 transition-colors">
              <div className="text-lg font-medium text-gray-700 mb-2">
                點擊或拖拽Excel檔案到此處
              </div>
              <div className="text-sm text-gray-500">支援 .xlsx、.xls 格式</div>
            </div>
          </Upload>

          {fileUpload.length > 0 && (
            <div className="mt-4 w-full">
              <div className="text-sm text-gray-600 mb-2">
                已載入 {fileUpload.length} 筆資料
              </div>
              <div className="flex gap-2">
                <Button
                  variant="default"
                  onClick={() => setIsUploadModalOpen(false)}
                >
                  關閉
                </Button>
                <Button
                  variant="filled"
                  color="blue"
                  onClick={() => {
                    handleUploadExcel(fileUpload);
                    setIsUploadModalOpen(false);
                  }}
                >
                  確認匯入
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <Table
        // rowSelection={{
        //   type: 'checkbox',
        //   ...rowSelection,
        // }}
        scroll={{ x: "max-content", y: 600 }}
        columns={columns}
        dataSource={fileUpload}
        pagination={{
          pageSize: pageSize,
          total: fileUpload.length,
          current: currentPage,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["20", "50", "100", "200"],
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        bordered
        sticky
      />
    </div>
  );
}

export default AddDesignBOM;
